import { useState, useEffect } from 'react';

/**
 * Custom hook for handling "Add to Home Screen" prompt
 * Returns [prompt, promptToInstall] where:
 * - prompt: the beforeinstallprompt event or null
 * - promptToInstall: function to trigger the install prompt
 */
function useAddToHomescreenPrompt() {
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const promptToInstall = async () => {
    if (!prompt) {
      return false;
    }

    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    setPrompt(null);
    return outcome === 'accepted';
  };

  return [prompt, promptToInstall];
}

// Export as both default and named export for compatibility
export default useAddToHomescreenPrompt;
export { useAddToHomescreenPrompt };

